export default __webpack_public_path__ + "static/media/INTEL HUB.242c1aa1.jpg";